export default class CurrentPage {
  static hasHash(string) {
    return window.location.hash === `#${string}`;
  }

  static setHash(string) {
    window.location.hash = `#${string}`;
  }

  static isArticle() {
    return window.ENV.article && window.ENV.article.id > 0;
  }

  static getArticleId() {
    if (this.isArticle()) {
      return window.ENV.article.id;
    } else {
      return -1;
    }
  }

  static getArticleAuthorId() {
    if (this.isArticle()) {
      return window.ENV.article.authorId;
    } else {
      return -1;
    }
  }

  static getArticleConversationHostId() {
    if (this.isArticle()) {
      return window.ENV.article.conversationHostId;
    } else {
      return -1;
    }
  }

  static getArticleUrl() {
    if (this.isArticle()) {
      return window.ENV.article.url;
    } else {
      return '';
    }
  }

  static getThreadReplyModalUrl() {
    return window.ENV.threadReplyModalUrl;
  }

  static getArticleUrlSafeTitle() {
    if (this.isArticle()) {
      return window.ENV.article.urlSafeTitle;
    } else {
      return '';
    }
  }

  static getTrackMetricsActionPath() {
    return window.ENV.trackMetricsActionPath;
  }

  static getUserGoalMarkTrackedActionPath() {
    return window.ENV.userGoalMarkTrackedActionPath;
  }

  static hasShareUrl() {
    return typeof window.ENV.shareUrl.id == 'number';
  }

  static getShareUrl() {
    return window.ENV.shareUrl;
  }

  static isUtmSourceFromPocket() {
    return (
      window.ENV.paywallIframe && window.ENV.paywallIframe.isUtmSourceFromPocket
    );
  }

  static isPaywallIframeLocked() {
    return window.ENV.paywallIframe && !window.ENV.paywallIframe.isUnlocked;
  }

  static paywallIframeSrc() {
    return window.ENV.paywallIframe.src;
  }

  static paywallIframeId() {
    return window.ENV.paywallIframe.id;
  }

  // Returns the current URL without the anchor.
  static getUrl() {
    return window.location.href.match(/(^[^#]*)/)[0];
  }
}
